export default String.raw`
.order-details {
    &__row {
        grid-template-columns: repeat(1, minmax(120px, 1fr));
    }
}

.side-menu {
    display: none;
}

.toggle-waybill-details {
    .waybill-details {
        &__row {
            grid-template-columns: repeat(1, minmax(120px, 1fr));
        }
    }
}

.customer-container {
    grid-template-columns: 100%;

    .customer-submenu {
        margin: 0;
        &__header {
            flex-direction: column;
            align-items: flex-start;

            .options {
                .dropdown {
                    right: auto !important;
                }
            }
        }
    }

    .change-data-container {
        padding: 18px;
    }
}

.submenu {
    justify-content: space-between;
    width: 100%;
}

@media screen and (max-width: 689px) {
    .details-info {
        flex-direction: column;
        gap: 0;
    }
  
    .details {
        flex-direction: row;
        padding-bottom: 32px;
    }
  
    .details-info__summary {
        width: 100%;
    }
}

@media screen and (max-width: 689px) {
    .customer-info {
        &__content {
            .info-icon:hover + .hover-text {
                top: 20px;
                left: 0;
            }
        }
    }
}

@media screen and (max-width: 390px) {
    .details-info {
        .summary {
            .title {
                width: 180px;
            }
        }
    }
}

.row {
    .options.drop {
        .open-dropdown-js,
        .close-dropdown-js,
        .delete-product-from-wishlist-js {
            opacity: 1;
        }
    }
}

.eshop__table-container {
    thead tr th.open-complaint-form-container-js::before {
        width: 100px;
    }

    td.complaint-actions-inline {
        .pure-button.complaint-action-btn {
            display: block;
            width: max-content;
            margin-left: auto;
            text-align: right;

            & + .complaint-action-btn {
                margin-left: auto;
                margin-top: 4px;
            }
        }
    }
}
`